<template>
    <!-- Display List -->
    <div class="access-list-individual" v-if="display === 'list'">
        <div
            v-if="
                isCreator === true &&
                checkRight('G_RESIDENCES') &&
                display === 'list'
            "
            class="list-creator"
            @click="createAction()"
        >
            <div>
                <i class="fas fa-plus"></i>
                <h1>{{ $t("accessCard.create") }}</h1>
            </div>
        </div>
        <div
            v-else-if="isConnectit === true && display === 'list'"
            class="access-list-connectit"
            @click="gotoConnectit()"
        >
            <div class="visual">
                <img
                    :src="imageBaseURL + 'Images/lora/connect_it_sm.png'"
                    alt="Connectit.it"
                />
            </div>
        </div>
        <div
            v-else-if="!isCreator"
            class="access-info"
            @mouseenter="isUnaffected ? animateText('enter') : null"
            @mouseleave="isUnaffected ? animateText('leave') : null"
        >
            <div class="access-list-image" @click="gotoAccess(access)">
                <img :src="imageBaseURL + access.image" alt="" />
                <!-- <i
                    title="Connecté"
                    v-if="
                        access.kibolt === '1' ||
                        parseInt(access.centrale_id, 10) > 0
                    "
                    class="fas fa-check-circle intercom-check"
                ></i> -->
                <div
                    class="unaffected"
                    title="Non connecté"
                    ref="unaffected"
                    v-if="isUnaffected"
                >
                    <i class="fa-solid fa-link-simple-slash"></i>
                    <p ref="text">{{ $t("global.status.unaffected") }}</p>
                </div>
            </div>
            <div class="access-list-name" @click="gotoAccess(access)">
                {{ access.nom }}
            </div>

            <div
                class="options"
                v-if="checkRightEvent || checkRightCode || checkRightBadge"
            >
                <button
                    class="options-button dropdown-toggle"
                    type="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                >
                    <i class="fas fa-ellipsis-v"></i>
                </button>
                <ul class="dropdown-menu" aria-labelledby="options-button">
                    <a
                        :class="
                            checkRight('G_RESIDENCES')
                                ? null
                                : 'disabled-dropdown-item'
                        "
                        class="dropdown-item"
                        @click="
                            checkRight('G_RESIDENCES')
                                ? goToAmazonKey(access)
                                : null
                        "
                        v-if="canUsedAmazonKey(access)"
                    >
                        <img
                            :src="require('@/assets/images/amazonKey/logo.svg')"
                            alt=""
                        />
                        {{ $t("amazonKey.title") }}
                        <i
                            v-if="!parseInt(access.amazon_key)"
                            title="Non Connecté"
                            class="fas fa-times-circle amazon-uncheck"
                        ></i>
                        <i
                            v-else-if="parseInt(access.amazon_key)"
                            title="Connecté"
                            class="fas fa-check-circle amazon-check"
                        ></i>
                    </a>
                    <a
                        @click="goToV1View('data/events/evts/id=' + access.id)"
                        class="dropdown-item"
                        v-if="checkRightEvent"
                    >
                        <i class="fas fa-calendar-day"></i>
                        {{ $t("accessCard.events") }}
                    </a>
                    <a
                        v-if="checkRightCode"
                        @click="goToV1View('data/codes/codes/id=' + access.id)"
                        class="dropdown-item"
                    >
                        <i class="fas fa-keyboard"></i>
                        {{
                            $t("accessCard.codes", {
                                count: access.codes_count,
                            })
                        }}
                    </a>
                    <a
                        v-if="checkRightBadge"
                        @click="
                            goToV1View(
                                'data/search_all/srch_all/fromacces=' +
                                    access.id
                            )
                        "
                        class="dropdown-item"
                    >
                        <i class="fas fa-key"></i>
                        {{
                            $t("accessCard.badges", {
                                count: access.cles_count,
                            })
                        }}
                    </a>
                    <a
                        v-if="checkRightOpenDoor"
                        @click="callOpenDoor(access.id)"
                        class="dropdown-item"
                    >
                        <i class="fas fa-door-open"></i>
                        {{ $t("accessCard.opendoor") }}
                    </a>
                </ul>
            </div>
        </div>
    </div>

    <!-- Display Card -->
    <div class="access-card-individual" v-if="display === 'card'">
        <div class="card-creator-wrapper">
            <div
                v-if="
                    isCreator === true &&
                    checkRight('G_RESIDENCES') &&
                    display === 'card'
                "
                class="card-creator"
                @click="createAction()"
            >
                <i class="fas fa-plus"></i>
                <h1>{{ $t("accessCard.create") }}</h1>
            </div>
        </div>
        <div
            v-if="isConnectit === true && display === 'card'"
            class="card-connectit"
            @click="gotoConnectit()"
        >
            <div class="visual">
                <img
                    :src="imageBaseURL + 'Images/lora/connect_it_sm.png'"
                    alt="Connectit.it"
                />
            </div>
        </div>
        <div
            v-else-if="!isCreator === true"
            class="access-card-content"
            @mouseenter="isUnaffected ? animateText('enter') : null"
            @mouseleave="isUnaffected ? animateText('leave') : null"
        >
            <div class="visual" @click="gotoAccess(access)">
                <img
                    class="material"
                    :src="imageBaseURL + access.image"
                    :alt="access.nom"
                />
                <!-- <i
                    title="Connecté"
                    v-if="
                        access.kibolt === '1' ||
                        parseInt(access.centrale_id, 10) > 0
                    "
                    class="fas fa-check-circle intercom-check"
                ></i> -->

                <div
                    class="unaffected"
                    title="Non connecté"
                    ref="unaffected"
                    v-if="isUnaffected"
                >
                    <i class="fa-solid fa-link-simple-slash"></i>
                    <p ref="text">{{ $t("global.status.unaffected") }}</p>
                </div>
            </div>
            <div class="details" @click="gotoAccess(access)">
                <h1>{{ access.nom }}</h1>
            </div>
            <div
                class="options"
                v-if="checkRightEvent || checkRightCode || checkRightBadge"
            >
                <button
                    class="options-button dropdown-toggle"
                    type="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                >
                    <i class="fas fa-ellipsis-v"></i>
                </button>
                <ul class="dropdown-menu" aria-labelledby="options-button">
                    <a
                        :class="
                            checkRight('G_RESIDENCES')
                                ? null
                                : 'disabled-dropdown-item'
                        "
                        class="dropdown-item"
                        @click="
                            checkRight('G_RESIDENCES')
                                ? goToAmazonKey(access)
                                : null
                        "
                        v-if="canUsedAmazonKey(access)"
                    >
                        <img
                            :src="require('@/assets/images/amazonKey/logo.svg')"
                            alt=""
                        />
                        {{ $t("amazonKey.title") }}
                        <i
                            v-if="!parseInt(access.amazon_key)"
                            title="Non Connecté"
                            class="fas fa-times-circle amazon-uncheck"
                        ></i>
                        <i
                            v-else-if="parseInt(access.amazon_key)"
                            title="Connecté"
                            class="fas fa-check-circle amazon-check"
                        ></i>
                    </a>
                    <a
                        @click="goToEventsRouting(access)"
                        class="dropdown-item"
                        v-if="checkRightEvent || checkVigikNC"
                    >
                        <i class="fas fa-calendar-day"></i>
                        {{ $t("accessCard.events") }}
                    </a>
                    <a
                        v-if="checkRightCode"
                        @click="goToV1View('data/codes/codes/id=' + access.id)"
                        class="dropdown-item"
                    >
                        <i class="fas fa-keyboard"></i>
                        {{
                            $t("accessCard.codes", {
                                count: access.codes_count,
                            })
                        }}
                    </a>
                    <a
                        v-if="checkRightBadge"
                        @click="
                            goToV1View(
                                'data/search_all/srch_all/fromacces=' +
                                    access.id
                            )
                        "
                        class="dropdown-item"
                    >
                        <i class="fas fa-key"></i>
                        {{
                            $t("accessCard.badges", {
                                count: access.cles_count,
                            })
                        }}
                    </a>
                    <a
                        v-if="checkRightOpenDoor"
                        @click="callOpenDoor(access.id)"
                        class="dropdown-item"
                    >
                        <i class="fas fa-door-open"></i>
                        {{ $t("accessCard.opendoor") }}
                    </a>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import v1mixin from "@/mixins/v1.js"
import { stairwellType } from "@/enums"
import { useToast } from "vue-toastification"
import httpIntratone from "@/services/httpIntratone.js"
import { openAccess } from "@/services/intratone/access.js"

const toast = useToast()

export default {
    name: "AccesCard",
    mixins: [v1mixin],
    props: {
        access: {
            type: Object,
            default: function () {
                return null
            },
        },
        isCreator: {
            type: Boolean,
            default: false,
        },
        isConnectit: {
            type: Boolean,
            default: false,
        },
        idEntity: {
            type: String,
            default: "",
        },
        typeEntity: {
            type: String,
            default: "",
        },
        idParent: {
            type: String,
            default: "",
        },
        entityParent: {
            type: String,
            default: "",
        },
        display: {
            type: String,
            default: "card",
        },
    },
    watch: {
        display: {
            immediate: true,
            handler() {
                this.displayMode = this.display
            },
        },
    },
    data() {
        return {
            imageBaseURL: process.env.VUE_APP_IMAGES_URL,
            stairwellType,
            createType: this.entityParent,
            idType: this.idParent,
            pathname: window.location.pathname,
        }
    },
    computed: {
        accessName() {
            const accessLength = 80
            let accessName = this.access.nom
            if (this.access.nom.length > accessLength) {
                accessName = this.access.nom.substring(0, accessLength) + " ..."
            }

            return accessName
        },
        getCentralId() {
            return this.access.centrale_id
                ? parseInt(this.access.centrale_id)
                : 0
        },
        checkRightEvent() {
            return (
                (this.access.clav === "1" ||
                    this.access.hf === "1" ||
                    this.access.lect === "1" ||
                    this.access.plat === "1" ||
                    this.access.pea !== "0" ||
                    this.access.pe !== "0" ||
                    this.access.idmatos !== "0" || // accès sans matériel
                    this.access.idmatos !== "14") && // carte HCR'
                this.getCentralId > 0 &&
                this.access.rw === "0" &&
                this.access.kibolt === "0" &&
                this.access.idmatos !== "13" && // centrale HIL
                (this.access.ecran === "" || this.access.ecran === "0") &&
                this.checkRight("G_EVENT")
            )
        },

        checkVigikNC() {
            return (
                (this.access.clav === "1" ||
                    this.access.hf === "1" ||
                    this.access.lect === "1" ||
                    this.access.plat === "1" ||
                    this.access.pea !== "0" ||
                    this.access.pe !== "0" ||
                    this.access.idmatos !== "0" || // accès sans matériel
                    this.access.idmatos !== "14") &&
                this.getCentralId > 0 &&
                this.access.rw === "1" &&
                this.access.kibolt === "0" &&
                this.access.idmatos !== "13" && // centrale HIL
                (this.access.ecran === "" || this.access.ecran === "0") &&
                this.checkRight("G_EVENT") &&
                parseInt(this.access.pcal_id) > 0
            )
        },
        checkRightCode() {
            return (
                (this.access.clav === "1" ||
                    this.access.plat === "1" ||
                    this.access.pea !== "0" ||
                    this.access.pe !== "0") &&
                this.getCentralId > 0 &&
                this.access.rw === "0" &&
                this.access.kibolt === "0" &&
                (this.checkRight("G_CODE_CLAV") ||
                    this.checkRight("G_CODE_TEL"))
            )
        },
        checkRightBadge() {
            return (
                this.access.hf === "1" ||
                this.access.lect === "1" ||
                this.access.kibolt === "1" ||
                this.access.plat === "1" ||
                this.access.pe !== "0" ||
                this.access.pea !== "0" ||
                this.access.idmatos === "0" || // accès sans matériel
                this.access.idmatos === "4" || // clavier hcc12
                this.access.idmatos === "14" || // carte HCR
                this.access.idmatos === "32" // haussmann sans lecteur
            )
        },
        checkRightOpenDoor() {
            return (
                this.access.rw === "0" &&
                this.access.lite === "0" &&
                this.access.kibolt === "0" &&
                this.getCentralId > 0 &&
                (this.access.ecran === "" || this.access.ecran === "0") &&
                this.checkPrivilege("OPEN_DOOR")
            )
        },

        isUnaffected() {
            return (
                (!this.access.kibolt === "1" ||
                    !parseInt(this.access.centrale_id, 10) > 0) &&
                this.access.idmatos !== "138"
            )
        },
    },
    methods: {
        async createAction() {
            if (this.typeEntity !== "") {
                if (this.typeEntity === stairwellType.BUILDING) {
                    this.createType = "building"
                } else if (this.typeEntity === stairwellType.STAIRWELL) {
                    this.createType = "stairwell"
                }
                this.idType = this.idEntity
            }
            let v1Call = null
            switch (this.createType) {
                case "apartment":
                    this.openV1Modal("data/appart/appart_add", "Act_Zone")
                    break
                case "stairwell":
                    if (this.idType) {
                        v1Call = await httpIntratone.post(
                            "data/cage/cage.php",
                            `id=${this.idType}&SID=${this.$store.getters["auth/getIntratoneDev2SID"]}`
                        )
                    }
                    this.openV1Modal("data/cage/action/cage_add", "Act_Zone")
                    break
                case "building":
                    if (this.idType) {
                        v1Call = await httpIntratone.post(
                            "data/batiment.php",
                            `id=${this.idType}&type=BATIMENT&SID=${this.$store.getters["auth/getIntratoneDev2SID"]}`
                        )
                    }
                    this.openV1Modal("data/batiment_add", "Act_Zone")
                    break
                case "residence":
                    this.openV1Modal("data/residence/add", "Act_Zone")
                    break
            }
        },

        gotoConnectit() {
            this.goToV1View("data/lora/res_devices/reset=1")
        },

        gotoAccess(access) {
            const redirectionInfo = `&from=${this.entityParent}&fromId=${this.idParent}`
            if (access.kibolt === "1") {
                this.$router.push({
                    path: `/${this.entityParent}/${this.idParent}/cylinder/${access.id}`,
                })
            } else {
                switch (access.idmatos) {
                    case "138": {
                        this.$router.push({
                            name: "PortaBox",
                            params: {
                                action: "edit",
                                id: access.id,
                            },
                        })
                        break
                    }
                    default:
                        this.goToV1View(
                            "data/acces/load/id=" + access.id + redirectionInfo
                        )
                        break
                }
            }
        },

        goToEventsRouting(access) {
            if (this.checkVigikNC) {
                this.goToV1View(`data/acces/vigik/logs/access_id=${access.id}`)
            } else {
                this.goToV1View("data/events/evts/id=" + access.id)
            }
        },

        async callOpenDoor(id) {
            let openAccessResponse = await openAccess(id)

            if (openAccessResponse === null) {
                throw new Error()
            }
            if (openAccessResponse.state === "error") {
                if (openAccessResponse.code === "API_RESTRICTED") {
                    this.$router.push({
                        path: "/error/401",
                    })
                } else {
                    this.$router.push({
                        path: "/error/404",
                    })
                }
                return
            } else {
                toast.success(this.$t("alerts.access.opendoor"), {
                    icon: "fas fa-door-open",
                })
            }
        },

        animateText(action) {
            const unaffected = this.$refs.unaffected
            const text = this.$refs.text

            if (action === "enter") {
                text.style.display = "block"

                requestAnimationFrame(() => {
                    const textWidth = text.offsetWidth

                    text.style.opacity = "1"
                    unaffected.style.width =
                        unaffected.offsetWidth + textWidth + 5 + "px"
                })
            } else {
                text.style.opacity = "0"

                requestAnimationFrame(() => {
                    text.style.display = "none"
                    unaffected.style.width = "40px"
                })
            }
        },
        async goToAmazonKey(access, kibolt) {
            const redirectionInfo = `&from=${this.entityParent}&fromId=${this.idParent}`
            let path = "data/acces/load/id=" + access.id + redirectionInfo

            if (kibolt === "1") {
                path = `/${this.entityParent}/${this.idParent}/cylinder/${access.id}`
            }

            const accessInfos = {
                name: access.nom,
                link: path,
                routeName: "AccessInfos",
            }

            this.$store.commit(
                "breadCrumb/pushOnClassicBreadCrumb",
                accessInfos
            )

            this.$router.push({
                name: "AmazonKey",
                params: { accessId: access.id },
            })
        },

        canUsedAmazonKey(access) {
            return (
                !(
                    (parseInt(access.lect) &&
                        parseInt(access.bac) &&
                        !parseInt(access.plat) &&
                        !parseInt(access.pe)) ||
                    parseInt(access.ecran) ||
                    parseInt(access.kibolt) ||
                    parseInt(access.rw) ||
                    parseInt(access.lite)
                ) &&
                (this.pathname === "/en/" ||
                    this.pathname === "/fr/" ||
                    this.pathname === "/de/" ||
                    this.pathname === "/it/" ||
                    this.pathname === "/es/" ||
                    this.pathname === "/")
            )
        },
    },
}
</script>

<style lang="scss">
@import "@/assets/scss/global.scss";
@import "@/assets/scss/variables/fontSize.scss";

.access-list-individual {
    width: 100%;
    display: flex;
    border: none;
    transition: all ease-in-out 150ms;
    border-bottom: 1px solid $grey-light;
    cursor: pointer;

    &:hover {
        background-color: $grey-light;
        transition: all ease-in-out 150ms;

        .options {
            button {
                background-color: $grey-light;
            }
        }

        .access-list-image {
            .unaffected {
                transition: all 0.2s ease-in-out;

                p {
                    transition: all 0.5s ease-in-out;
                }
            }
        }
    }

    .list-creator {
        display: flex;
        gap: 1em;
        width: 100%;
        height: 100%;
        padding: 1em 3em;
        cursor: pointer;
        transition: background-color 200ms;
        border: none;

        div {
            display: flex;
            align-items: center;
            gap: 1em;

            i {
                color: $orange-neutral;
                font-size: $big;
                margin: auto;
            }

            h1 {
                margin: 0 !important;
                font-size: $normal;
                font-family: $font_avenir_heavy;
                color: $orange-neutral;
            }
        }

        &:hover {
            background-color: $orange-residence-dark;
        }
    }

    .access-list-connectit {
        border: none;
        display: flex;
        justify-content: center;
        grid-column: span 3 / span 3;
        padding: 0.5em 2em;
        transition: all 200ms;
        width: 100%;

        img {
            max-height: 40px;
        }
    }

    .access-info {
        width: 100%;
        display: grid;
        grid-template-columns: 1fr 10fr 1fr;
        gap: 1em;
        padding: 0.5em 0;
        border-radius: 10px;
        transition: background-color 200ms;

        .access-list-image {
            width: 100px;
            display: flex;
            align-items: center;
            justify-content: center;
            position: relative;

            img {
                max-height: 40px;
            }

            .unaffected {
                position: absolute;
                top: -15px;
                left: 80px;
                display: flex;
                height: 25px;
                gap: 0.4em;
                align-items: center;
                color: $red-uncheck;
                border: 1px $red-uncheck solid;
                padding: 0 10px;
                border-radius: 100px;
                background-color: $white;
                width: max-content;
                width: 40px;
                transition: all 0.2s ease-in-out;

                p {
                    transition: all 0.5s ease-in-out;
                    color: $red-uncheck;
                    margin: 0;
                    text-wrap: nowrap;
                    opacity: 0;
                    display: none;
                }

                i {
                    margin-top: 2.5px;
                    display: flex;
                    align-items: center;
                }
            }
        }

        .access-list-name {
            font-size: $normal;
        }
    }

    .access-list-name {
        align-self: center;
        width: 100%;
        font-size: $small;
        font-family: "Avenir Heavy";
    }

    .options {
        width: 100%;
        padding-right: 1em;
        display: flex;
        align-items: center;
        justify-content: end;
        justify-items: end;

        button {
            border-radius: 30px;
            border: none;
            padding: 6px 6px 5px 6px;
            transition: background-color 200ms;
            display: flex;
            align-items: center;
            justify-content: center;
            background-color: $white;

            i {
                font-size: $big;
                color: $blue-neutral;
            }
        }

        button:hover {
            background-color: $grey-light;
        }

        .dropdown-item {
            font-size: $small;
            transition: background-color 200ms, color 200ms, padding 200ms;
            color: $blue-neutral;
            font-family: "Avenir Heavy";

            i {
                font-size: $big;
                margin-right: 15px;
            }

            img {
                // object-fit: contain;
                height: 14px;
                margin-right: 15px;
            }

            .amazon-uncheck {
                color: $pink;
                font-size: $small;
            }

            .amazon-check {
                color: $green-check;
                font-size: $small;
            }
        }

        .dropdown-item:hover {
            cursor: pointer;
            color: $orange-neutral;
            background-color: $grey-lighter;
            padding-left: 30px;
        }

        .dropdown-toggle:after {
            display: none;
        }
    }
}

.access-card-individual {
    position: relative;
    display: flex;
    align-items: center;
    gap: 1em;
    min-height: 55px;
    max-height: max-content;
    border-radius: 15px;
    transition: all 200ms;

    @media all and (max-width: 1024px) and (min-width: 768px) {
        width: 100%;
    }

    @media all and (max-width: 768px) {
        width: 100%;
    }

    &:hover {
        .visual {
            .unaffected {
                // width: 120px;
                transition: all 0.2s ease-in-out;

                p {
                    transition: all 0.5s ease-in-out;
                }
            }
        }
    }

    .access-card-content {
        padding: 0.4em 0.8em;
        border-radius: 0.4em;
        display: flex;
        transition: all 150ms;
        width: 100%;
        border: 1px solid $grey-light;

        &:hover {
            cursor: pointer;
            background-color: $grey-light;
            transition: all 150ms;

            .options {
                button {
                    background-color: $grey-light;
                }
            }
        }
    }

    .visual {
        min-width: max-content;
        width: 9em;
        border-right: none;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;

        img {
            max-height: 40px;
        }

        .unaffected {
            position: absolute;
            top: -10px;
            right: 0;
            display: flex;
            height: 25px;
            gap: 0.4em;
            align-items: center;
            color: $red-uncheck;
            border: 1px $red-uncheck solid;
            padding: 0 10px;
            border-radius: 100px;
            background-color: $white;
            width: max-content;
            width: 40px;
            transition: all 0.2s ease-in-out;

            p {
                transition: all 0.5s ease-in-out;
                color: $red-uncheck;
                margin: 0;
                text-wrap: nowrap;
                opacity: 0;
                display: none;
            }

            i {
                margin-top: 2.5px;
                display: flex;
                align-items: center;
            }
        }

        .intercom-check {
            color: $green-check;
        }

        .intercom-uncheck {
            color: $red-uncheck;
        }

        .material {
            max-width: 50px;
        }
    }

    .details {
        @media all and (min-width: 1024px) {
            width: 100%;
        }

        @media all and (max-width: 1024px) and (min-width: 768px) {
            width: 100%;
        }

        @media all and (max-width: 768px) {
            width: 100%;
        }

        padding: 0 8px 0 0;
        display: flex;
        align-items: center;
        cursor: pointer;

        h1 {
            width: 100%;
            color: $blue-neutral;
            font-family: "Avenir Heavy";
            text-align: left;
            font-size: $small;
            margin: 0;
            line-height: 22px;
            transition: color 200ms;

            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
            text-overflow: ellipsis;
            word-break: break-word;
        }
    }

    .options {
        width: max-content;
        padding-right: 1em;
        display: flex;
        align-items: center;
        justify-content: end;

        button {
            border-radius: 30px;
            border: none;
            padding: 6px 6px 5px 6px;
            transition: background-color 200ms;
            background-color: $white;

            i {
                font-size: $big;
                color: $blue-neutral;
            }
        }

        button:hover {
            background-color: $grey-dark;
        }

        .dropdown-item {
            font-size: $small;
            transition: background-color 200ms, color 200ms, padding 200ms;
            color: $blue-neutral;
            font-family: "Avenir Heavy";

            i {
                font-size: $big;
                margin-right: 15px;
            }

            img {
                object-fit: contain;
                height: 14px;
                margin-right: 15px;
            }

            .amazon-uncheck {
                color: $pink;
                font-size: $small;
            }

            .amazon-check {
                color: $green-check;
                font-size: $small;
            }
        }

        .dropdown-item:hover {
            cursor: pointer;
            color: $orange-neutral;
            background-color: $grey-lighter;
            padding-left: 30px;
        }

        .dropdown-toggle:after {
            display: none;
        }
    }

    .card-creator-wrapper {
        display: flex;
        justify-content: center;
        height: 100%;

        .card-creator {
            display: flex;
            gap: 1em;
            align-items: center;
            justify-content: center;
            width: 100%;
            height: 100%;
            padding: 1em 3em;
            border-radius: 15px;
            cursor: pointer;
            background-color: $orange-neutral;
            transition: background-color 200ms;
            color: $white;
            border: none;

            &:hover {
                background-color: $orange-light;
                border: none;
                transition: background-color 200ms;
            }

            i {
                color: $white;
                font-size: $big;
            }

            h1 {
                font-size: $normal;
                font-family: $font_avenir_heavy;
                color: $white;
                margin: 0;
            }
        }
    }
}

.card-connectit {
    width: 100%;
    cursor: pointer;
    border: 1px solid $grey-light;
    transition: background-color 200ms;
    padding: 0.4em 0.8em;
    border-radius: 0.7em;

    .visual {
        width: 100%;
    }

    @media all and (max-width: 1024px) and (min-width: 768px) {
        width: 100%;
    }

    @media all and (max-width: 768px) {
        width: 100%;
    }

    &:hover {
        background-color: $grey-light;
        transition: background-color 200ms;
    }
}
</style>
